import { helper } from '@ember/component/helper';

// Mappa dei tipi di campo - definita fuori dalla funzione per evitare ricreazione
const FIELD_MAPPING = Object.freeze({
  text: 'text',
  textarea: 'textarea',
  number: 'number',
  dropbox: 'dropbox',
  checkbox: 'checkbox',
  date: 'date',
  currency: 'currency',
  range: 'range',
  suggestion: 'suggestion',
  table: 'table',
  calculated: 'calculated',
  relation: 'Relazione',
  advancedTextarea: 'advanced-textarea'
});
const DEFAULT_FIELD = 'text';

/**
 * Ritorna il nome leggibile di un tipo di campo personalizzato
 */
function humanCustomFieldName([fieldType]) {
  return FIELD_MAPPING[fieldType] ?? DEFAULT_FIELD;
}
var humanCustomFieldName$1 = helper(humanCustomFieldName);

export { humanCustomFieldName$1 as default, humanCustomFieldName };
//# sourceMappingURL=human-custom-field-name.js.map
